import Utilities from "../utilities/utilities";

export default class websiteMessage {
	/**
	 * @param {Object} options - User options
	 */
	constructor(options) {
		window.addEventListener("DOMContentLoaded", () => {
			this.init();
		});

		window.addEventListener("NAVIGATE_IN", () => {
			this.init();
		});

		window.addEventListener("infiniteScrollAppended", () => {
			this.init();
		});
	}

	init() {
		var elName = ".js-website-sticky-footer-message";
		var elClose = ".js-website-sticky-footer-message-close";

		var $el = jQuery(elName);

		if ($el.length == 0) {
			return;
		}

		if (Utilities.getCookie("cookie-sticky-footer-message")) {
			jQuery(elName).remove();
		}

		jQuery(elClose).on("click", function (e) {
			const cookieCalcHour = 2;
			Utilities.setCookie(
				"cookie-sticky-footer-message",
				"active",
				cookieCalcHour
			);

			jQuery(elName).remove();
		});
	}
}
